// extracted by mini-css-extract-plugin
export default {"peopleNameCell":"freemium-people_peopleNameCell__IoW3F","peopleActions":"freemium-people_peopleActions__zlMQu"};